import { render, staticRenderFns } from "./PurchaseCollectionSearch.vue?vue&type=template&id=8f0851f2&"
import script from "./PurchaseCollectionSearch.vue?vue&type=script&lang=js&"
export * from "./PurchaseCollectionSearch.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseCollectionSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports